function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "742D33CB-FE40-46FA-AE97-4F249CC39990");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Asset-Artboard-Page",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "ico/ustawienia-ico/upload",
  transform: "translate(0.250000, 0.000000)"
}, React.createElement("g", {
  id: "ico/profil"
}, React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 80,
  height: 80
}), React.createElement("path", {
  d: "M62.5,31.5587252 C62.03125,20.8381923 53.125,12.5 41.875,12.5 C31.9140625,12.5 23.4765625,18.8132027 21.484375,27.7469801 L20.3125,27.7469801 C14.6875,27.7469801 10,32.9881295 10,39.1822152 C10,45.1380668 14.453125,49.6645141 20.3125,49.6645141 L20.3125,47.7586415 C15.5078125,47.7586415 11.875,44.0660135 11.875,39.1822152 C11.875,34.0601828 15.7421875,29.6528526 20.3125,29.6528526 L23.0078125,29.6528526 L23.125,28.8190334 C24.6484375,20.4808412 32.5,14.4058725 41.875,14.4058725 C52.421875,14.4058725 60.625,22.3867137 60.625,32.5116614 L60.625,33.4645977 L61.5625,33.4645977 C65.4296875,33.4645977 68.125,37.5145768 68.125,41.0880877 C68.125,44.8998328 65.3125,47.7586415 61.5625,47.7586415 L61.5625,49.6645141 C66.3671875,49.6645141 70,45.9718861 70,41.0880877 C70,36.7998746 67.0703125,32.1543103 62.5,31.5587252 Z M40.9480007,27.7655685 L49.8994958,36.7758762 L48.4852822,38.2012808 L41.882,31.544 L41.8829545,67.5000012 L39.9920455,67.5000012 L39.992,31.566 L33.4142141,38.2012808 L32.0000005,36.7758762 L40.9480007,27.7655685 Z",
  id: "Shape",
  fill: "#00965E"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "81px",
    height: "80px",
    viewBox: "0 0 81 80",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/upload.9bbbda43.svg";
export { SvgComponent as ReactComponent };